// frontend/src/services/reportsApi.js
import { http } from "./http";

function buildQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    q.set(k, String(v));
  });
  const qs = q.toString();
  return qs ? `?${qs}` : "";
}

function getApiBase() {
  return (
    (typeof import.meta !== "undefined" &&
      import.meta.env?.VITE_API_BASE?.replace(/\/+$/, "")) ||
    (process.env.REACT_APP_API_BASE &&
      process.env.REACT_APP_API_BASE.replace(/\/+$/, "")) ||
    "http://localhost:5050"
  );
}

export function getReportSummary(token, params = {}) {
  return http(`/api/admin/reports/summary${buildQuery(params)}`, { token });
}

/**
 * GET /api/admin/reports/users/:userId/course-rollup?courseSlug=
 */
export function getUserCourseRollup(token, userId, params = {}) {
  return http(
    `/api/admin/reports/users/${encodeURIComponent(
      String(userId)
    )}/course-rollup${buildQuery(params)}`,
    { token }
  );
}

/**
 * Downloads return blob
 * Backend routes:
 *  - GET /api/admin/reports/csv
 *  - GET /api/admin/reports/pdf
 */
export async function downloadCsv(token, params = {}) {
  const API_BASE = getApiBase();
  const url = `${API_BASE}/api/admin/reports/csv${buildQuery(params)}`;

  const res = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
    credentials: "include",
  });

  if (!res.ok) throw new Error(`CSV download failed (HTTP ${res.status})`);
  return res.blob();
}

export async function downloadPdf(token, params = {}) {
  const API_BASE = getApiBase();
  const url = `${API_BASE}/api/admin/reports/pdf${buildQuery(params)}`;

  const res = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
    credentials: "include",
  });

  if (!res.ok) throw new Error(`PDF download failed (HTTP ${res.status})`);
  return res.blob();
}
